<template>
    <div>
        <!--调拨详情-->
        <Card :bordered="false" dis-hover>
            <p slot="title">详情</p>
            <Row>
                <Col span="8"><strong>调拨类型：</strong>
                    <span class="result" v-if="pageData.type==0">已调入</span>
                    <span class="result" v-if="pageData.type==1">已调出</span>
                </Col>
                <Col span="8"><strong>调拨店铺：</strong> <span class="result">{{pageData.comename}}</span></Col>
                <Col span="8"><strong>订单号：</strong> <span class="result">{{pageData.code}}</span></Col>
                <Col span="8"><strong>调拨数量：</strong> <span class="result">{{nums}}</span></Col>
                <Col span="8"><strong>调拨人：</strong> <span class="result">{{pageData.adminName}}</span></Col>
                <Col span="8"><strong>调拨时间：</strong> <span class="result">{{pageData.time}}</span></Col>

            </Row>
        </Card>
            <table slot="content" class="ive-table" v-for="(item, index) in pageData.goods" :key="index" style="width: 99%">
                <thead>
                <th>商品详情</th>
                <th>名称/货号</th>
                <th>规格/颜色</th>
                <th>数量</th>
                </thead>
                <tbody>
                <tr align="center" v-for="(k,v) in pageData.goods[index].itmes">
                    <td width="200" :rowspan="v" v-if="v==0">
                        <Fy-Img
                                :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                                :Width="100"
                                :Height="100"
                        ></Fy-Img>
                    </td>
                    <td>{{item.goodsname}} / {{item.goodscode}}</td>
                    <td> {{k.size}} / {{k.color}}</td>
                    <td>{{k.quantity}}</td>
                </tr>
                </tbody>
            </table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                nums:0,
                pageData:{}
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.getInventory(this.$route.query.id)

        },

        methods: {
            //获取采购单
            getInventory(id){
                this.$Api.getInventory({
                    id:id
                }).then(res => {
                    if(res.code==200){
                        this.pageData = res.data
                         this.pageData.goods.forEach((item,index)=>{
                             item.itmes.forEach((m,n)=>{
                                 this.nums=this.nums + m.quantity
                             })
                         })

                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },


        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        display: inline-block;
        margin-bottom: 15px;
    }
    .ive-table{
        margin-top: 20px;
        width: 100%;
        border-collapse: collapse;
        th{
            background: #bfdeff;
            padding: 10px;
        }
        tr td{
            border: 1px solid #ececec;
            padding: 10px;
        }
    }
</style>